import { useSuspenseQuery } from "@tanstack/react-query";
import { useAuth } from "@babackapp/auth-client/hooks";

export default function useViewerId() {
  const auth = useAuth();

  return useSuspenseQuery({
    queryKey: ["viewer"],
    queryFn: () => {
      if (!auth.isLoading && auth.user) return auth.user.id;
      return null;
    },
  });
}
